import { CORE_WORKSPACE_ROUTES } from "./coreRoutes";
import { ENGAGEMENT_WORKSPACE_ROUTES } from "./engagementRoutes";
import { ADMIN_WORKSPACE_ROUTES } from "./adminRoutes";

export const WORKSPACE_ROUTES = [
  ...CORE_WORKSPACE_ROUTES,
  ...ENGAGEMENT_WORKSPACE_ROUTES,
  ...ADMIN_WORKSPACE_ROUTES,
];
